/**
 * Content-layer config (PRP-11) — build-time values the WordPress content
 * components read. See wordpress/README.md for the matching WP-side config (engine in KGP-WebHosting-Tools).
 */

import { env } from './env';

/** REST base of the site's grouping taxonomy (e.g. 'services', 'programs'). */
export const groupingTaxonomy: string = env.VITE_WP_GROUPING_TAXONOMY;

export type SocialNetwork = 'facebook' | 'instagram' | 'x' | 'linkedin' | 'youtube';

export interface SocialLink {
  network: SocialNetwork;
  label: string;
  url: string;
}

const SOCIAL_ENV: Array<[SocialNetwork, string, string]> = [
  ['facebook', 'Facebook', env.VITE_SOCIAL_FACEBOOK],
  ['instagram', 'Instagram', env.VITE_SOCIAL_INSTAGRAM],
  ['x', 'X', env.VITE_SOCIAL_X],
  ['linkedin', 'LinkedIn', env.VITE_SOCIAL_LINKEDIN],
  ['youtube', 'YouTube', env.VITE_SOCIAL_YOUTUBE],
];

/** Configured social profiles, in display order. Empty when none are set. */
export const socialLinks: SocialLink[] = SOCIAL_ENV.filter(([, , url]) => url !== '').map(
  ([network, label, url]) => ({ network, label, url })
);
